export const LOAD_ACTIVITY_PANE = 'LoadActivityPane';

export const ACTIVITY_PANE_LOADED = 'ActivityPaneLoaded';

export const ACTIVITY_PANE_ERROR = 'ActivityPaneError';
